import {FC} from 'react';

export const EnableNotificationsBanner: FC = () => {
  return null;
};

export default EnableNotificationsBanner;
